export const CARD_HEIGHT = 138
export const EDIT_SECTION_EXTRA_HEIGHT = 150
export const LIST_BOTTOM_MARGIN = 250
export const TOOLBAR_OFFSET = 30
export const EDIT_ITEM_OFFSET = 20
export const ADD_OPTION_TOP_MARGIN = 20
export const MAX_NUMBER_OF_ITEMS = 25
